export default Object.freeze({
  JIRA: 'JIRA',
  REMEDY: 'REMEDY',
  SAMANAGE: 'SAMANAGE',
  SERVICENOW: 'SERVICENOW',
});
